export default __webpack_public_path__ + "static/media/img (2).d2abfbd5.jpg";